import { Checkbox, Icon, Label, Text } from "@salestrak/ui";

type MoreOptionsInputProps = {
  value: unknown;
  onChange: (value: unknown) => void;
};

/**
 * Quick filter toggle for "Show archived" issues.
 * When checked, sets value to `true` so the query includes archived items.
 */
export function MoreOptionsInput({ value, onChange }: MoreOptionsInputProps) {
  // Checkbox has no label slot; the `Label` wraps both parts.
  return (
    <Label>
      <Checkbox
        checked={value === true}
        onCheckedChange={(checked) => onChange(checked ? true : null)}
      />
      <Icon name="archive" size="lg" color="muted" />
      <Text size="sm" weight="normal">
        Show only archived
      </Text>
    </Label>
  );
}
